import { useLocation } from 'react-router-dom';

type RouteExcludeProps = {
  paths: string[];
  children: React.ReactNode;
};

/**
 * Conditionally renders children only when current path is NOT in the excluded list.
 * Matches exact paths or their sub-routes (e.g., /notifications or /notifications/123).
 */
export const RouteExclude = ({ paths, children }: RouteExcludeProps) => {
  const location = useLocation();
  const isExcluded = paths.some(
    (path) =>
      location.pathname === path || location.pathname.startsWith(`${path}/`)
  );

  return isExcluded ? null : <>{children}</>;
};
